/* iFungi — PS7 presentation refinements
 * 2026-09-19: restore the main price row on the PS7 product page.
 * The buy-box controller remains the single owner of price calculations,
 * selected variants, selling plans, Add to Cart, and express checkout.
 * Keep the existing Amazon-to-FAQ spacing and quantity defaults unchanged.
 * Update the restored row's servings label when the selected pack changes.
 * Loaded after ifungi-ps7-buybox.js from layout/theme.liquid (PS7 page only).
 */
(function () {
  if (window.__ps7AovPatch) return;
  window.__ps7AovPatch = true;

  (function injectStyles() {
    var s = document.createElement('style');
    s.id = 'ps7-aov-style';
    /* Do not hide .ps7-price-wrap: its existing Liquid/JS price is authoritative. */
    s.textContent = '.ps7-hero .ps7-amazon-link { margin-bottom:34px; }';
    document.head.appendChild(s);
  })();

  function syncServings() {
    var label = document.getElementById('ps7-servings-label');
    var state = window.ps7State;
    var variants = window.ps7Variants;
    if (!label || !state || !variants) return;
    var variant = variants[state.currentQty];
    if (!variant || !Number.isFinite(variant.bags) || variant.bags < 1) return;
    var servings = variant.bags * 100;
    var french = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
    label.textContent = '\u00a0\u00a0(' + servings + (french ? ' portions)' : ' Servings)');
  }

  function init() {
    /* Preserve the native one-bag default and the shopper's own selections. */
    syncServings();
    document.querySelectorAll('.ps7-qty-dropdown, input[name="ps7-purchase-type"], #ps7-delivery-freq').forEach(function (control) {
      /* The earlier buy-box listener reconciles quantity/purchase state first. */
      control.addEventListener('change', syncServings);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
